import styles from './QuestionTags.module.scss'

const MAX_TAGS = 8

interface QuestionTagsProps {
  tags: string[]
}

const QuestionTags = ({ tags }: QuestionTagsProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.shapesContainer}>
        {tags.slice(0, MAX_TAGS).map(tag => (
          <p key={tag} className={styles.shape}>
            {tag}
          </p>
        ))}
      </div>
    </div>
  )
}

export default QuestionTags
